import { render, staticRenderFns } from "./HotelSkeleton.vue?vue&type=template&id=4b37cf06&scoped=true&"
import script from "./HotelSkeleton.vue?vue&type=script&lang=js&"
export * from "./HotelSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./HotelSkeleton.vue?vue&type=style&index=0&id=4b37cf06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b37cf06",
  null
  
)

export default component.exports